import styled from 'styled-components'

const ModalRaceCoditionsStyled = styled.div`
  width: 952px;
  position: relative;
  background-color: #4df285;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px;

  .user-create_race-modal {
    background-color: ${({ theme }) => theme.color.neutral};
    clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
    padding: 20px 30px;
    position: relative;
    min-height: 300px;
    min-width: 950px;
    .close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: ${({ theme }) => theme.color.transparent};
      border: none;
      z-index: 1;
    }

    .line-condition {
      border-bottom: 2px solid ${({ theme }) => theme.color.lightGreen};
    }

    .height-85 {
      height: 90px;
    }

    .height-45 {
      height: 45px;
    }

    .title-create-race-container {
      padding-bottom: 10px;
      font-size: 30px;
      font-weight: 600;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
    }

    .create-race-container {
      display: flex;
      align-items: center;
      .ant-form {
        width: 100%;
      }

      .color-DEDEDE {
        color: #DEDEDE;
      }

      .title-label {
        display: flex;
        align-items: center;
        font-size: 18px;
      }

      .condition__checkbox {
        width: 12%;
        position: relative;
        padding: 30px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        line-height: 28px;
        font-size: 18px;
        .orange__line--checkbox {
          left: 0;
          bottom: -1px;
          width: 100%;
          height: 3px;
        }
        .condition__checkbox--text {
          height: 28px;
        }
        .mg__top--0 {
          margin-top: 0;

          label:before {
            margin-right: 0;
          }
          .border__cover {
            left: 16px;
            background-color: #191d2c;
          }
        }
      }

      .guil__content--checkbox {
        margin-top: 15px;
        line-height: 1.5715;
        position: relative;

        .guild__create--checkbox {
          padding: 0;
          height: initial;
          width: initial;
          margin-bottom: 0;
          display: none;
          cursor: pointer;
        }

        label {
          position: relative;
          cursor: pointer;
          font-size: 18px !important;
        }

        label:before {
          content: "";
          -webkit-appearance: none;
          background-color: transparent;
          border: 2.11952px solid #4EF076;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
            inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
          padding: 8px;
          display: inline-block;
          position: relative;
          vertical-align: middle;
          cursor: pointer;
          margin-right: 15px;
          background-color: #252B43;
          top: -2px;
        }

        .guild__create--checkbox:checked + label:after {
          content: "";
          display: block;
          position: absolute;
          top: 5px;
          left:6px;
          width: 8px;
          height: 12px;
          border: solid #4EF076;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
          background-color: #252B43;
        }
        .border__cover {
          display: block;
          position: absolute;
          top: -4px;
          left:28px;
          width: 8.5px;
          height: 14px;
          border: solid #4EF076;
          border-width: 0 0 2px 0;
          transform: rotate(45deg);
          background-color: #121212;
        }
      }

      .btn-create {
        display: flex;
        justify-content: center;
        padding-top: 20px;
        width: 100%;
        gap: 20px;

        .ant-form-item {
          margin: 0;
        }
      }
    }

    .img_race_condition {
      width: 36px;
      height: 36px;
    }

    .mg__left_5 {
      margin-left: 5px;
    }

    .pointer_race_condition {
      cursor: pointer;
      position: relative;
      width: 36px;
      height: 36px;
    }

    .icon_disable_condition {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 10px;
      height: 10px;
    }
  }
`

export default ModalRaceCoditionsStyled
